import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import Swal from "sweetalert2";
import PackageSelect from "../../../components/Shipment/register/PackageSelect";
import { postMethod } from "../../../function/helper";
import CallForPriceModal from "./CallForPriceModal";
import SearchCity from "./components/SearchCity";
import "./quickPrice.css";

const QuickPriceF = () => {
  const [priceModal, setPriceModal] = useState(false);
  const [data, setData] = useState([]);
  const [weight, setWeight] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [rialValue, setRialValue] = useState("");
  const [senderCity, setSenderCity] = useState("");
  const [recieverCity, setRecieverCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    needPackaging: false,
    needSMS: false,
    needPrint: false,
    needCollecting: false,
    packaging: "0",
  });

  const callForPrice = async () => {
    const payLoad = {
      senderCity,
      recieverCity,
      weight,
      rialValue,
      length,
      height,
      width,
      needPackaging: details?.needPackaging,
      needSMS: details?.needSMS,
      needPrint: details?.needPrint,
      needCollecting: details?.needCollecting,
      packageTypeId: details.packaging,
    };

    setLoading(true);
    const pishtazData = postMethod(
      "/price-inquiry/v1/post",
      {
        ...payLoad,
        serviceTypeId: 7,
      },
      { timeout: 18000 }
    );
    const vizheData = postMethod(
      "/price-inquiry/v1/post",
      {
        ...payLoad,
        serviceTypeId: 9,
      },
      { timeout: 18000 }
    );
    const mahexData = postMethod(
      "/price-inquiry/v1/mahex",
      {
        ...payLoad,
        serviceTypeId: 6,
      },
      { timeout: 18000 }
    );
    const chaparData = postMethod(
      "/price-inquiry/v1/chapar",
      {
        ...payLoad,
        serviceTypeId: 1,
      },
      { timeout: 18000 }
    );
    const tipaxData = postMethod(
      "/price-inquiry/v1/tipax",
      {
        ...payLoad,
        serviceTypeId: 12,
      },
      { timeout: 18000 }
    );
    const dekapostData = postMethod(
      "/price-inquiry/v1/dekapost",
      {
        ...payLoad,
        serviceTypeId: 14,
      },
      { timeout: 18000 }
    );
    const parsiPostData = postMethod(
      "/price-inquiry/v1/parsiPost",
      {
        ...payLoad,
        serviceTypeId: 1,
      },
      { timeout: 18000 }
    );
    const avaexpressData = postMethod(
      "/price-inquiry/v1/avaexpress",
      {
        ...payLoad,
        serviceTypeId: 1,
      },
      { timeout: 18000 }
    );

    const callPrice = await Promise.all([
      pishtazData,
      vizheData,
      mahexData,
      chaparData,
      tipaxData,
      dekapostData,
      parsiPostData,
      avaexpressData,
    ]);

    setLoading(false);

    const result = callPrice
      .filter(item => item && item.status === 200)
      .map(item => item.data.data);

    const sortedResult = result.sort((a, b) => {
      if (a.totalPrice > b.totalPrice) {
        return 1;
      }
      return -1;
    });

    setPriceModal(true);
    setData(sortedResult);
  };

  const callPriceBtn = () => {
    let message = null;

    if (!rialValue) {
      message = "ارزش کالا الزامی";
    }
    if (!details.packaging || details.packaging === "0") {
      message = "نوع بسته بندی الزامی";
    }
    if (!height) {
      message = "ارتفاع الزامی";
    }
    if (height < 1 || height > 250) {
      message = "ارتفاع باید بین 1سانتی متر و 250 سانتی متر باشد";
    }
    if (!width) {
      message = "عرض الزامی";
    }
    if (width < 1 || width > 250) {
      message = "عرض باید بین 1سانتی متر و 250 سانتی متر باشد";
    }
    if (!length) {
      message = "طول الزامی";
    }
    if (length < 1 || length > 250) {
      message = "طول باید بین 1سانتی متر و 250 سانتی متر باشد";
    }

    if (!weight) {
      message = "وزن الزامی";
    } else if (weight < 0.05 || weight > 100) {
      message = "وزن باید بین 0.05 کیلوگرم (50 گرم) و 100 کیلوگرم باشد";
    }

    if (!recieverCity) {
      message = "شهر گیرنده الزامی";
    }
    if (!senderCity) {
      message = "شهر فرستنده الزامی";
    }

    if (message !== null) {
      Swal.fire({
        icon: "warning",
        confirmButtonText: "متوجه شدم",
        title: message,
      });
      return;
    }

    callForPrice();
  };

  return (
    <section>
      <h4 className="p-4">محاسبه سریع قیمت پستی</h4>

      <form
        className="d-block px-2 quick-price-form"
        onSubmit={e => e.preventDefault()}
        onKeyDown={e => {
          if (e.key === "Enter" && e.target.nodeName === "INPUT") {
            const form = e.target.form;
            if (form?.elements === undefined) return;

            const index = Array.prototype.indexOf.call(form.elements, e.target);
            if (form.elements[index + 1]) {
              form.elements[index + 1].focus();
            }
            e.preventDefault();
          }
        }}
      >
        <Row>
          <Col xl={6} lg={6} md={6} sm={12} className="mb-2">
            <Form.Label>شهر - استان فرستنده:</Form.Label>
            <SearchCity onChoose={cityId => setSenderCity(cityId)} />
          </Col>

          <Col xl={6} lg={6} md={6} sm={12} className="mb-2">
            <Form.Label>شهر - استان گیرنده:</Form.Label>
            <SearchCity onChoose={cityId => setRecieverCity(cityId)} />
          </Col>

          <Col xl={6} lg={6} md={6} sm={12} className="mb-2">
            <Form.Label>وزن(کیلوگرم):</Form.Label>
            <Form.Control
              type="number"
              name="weight"
              onChange={e => setWeight(e.target.value)}
            />
          </Col>

          <Col xl={6} lg={6} md={6} sm={12} className="mb-2">
            <Row>
              <Col>
                <Form.Label>طول(cm):</Form.Label>
                <Form.Control
                  type="number"
                  name="size"
                  onChange={e => setLength(e.target.value)}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>عرض(cm):</Form.Label>
                <Form.Control
                  type="number"
                  name="size"
                  onChange={e => setWidth(e.target.value)}
                ></Form.Control>
              </Col>
              <Col>
                <Form.Label>ارتفاع(cm):</Form.Label>
                <Form.Control
                  type="number"
                  name="size"
                  onChange={e => setHeight(e.target.value)}
                ></Form.Control>
              </Col>
            </Row>
          </Col>

          <Col
            xl={6}
            lg={6}
            md={6}
            sm={12}
            className="d-flex flex-column justify-content-end mb-2"
          >
            <Form.Label>نوع بسته بندی:</Form.Label>

            <PackageSelect
              onChange={value =>
                setDetails(prevDetails => ({
                  ...prevDetails,
                  packaging: value,
                }))
              }
            />
          </Col>

          <Col xl={6} lg={6} md={6} sm={12} className="mb-2">
            <Form.Label>ارزش ریالی مرسوله:</Form.Label>
            <NumericFormat
              className="form-control"
              name="rialValue"
              thousandSeparator=","
              suffix=" ریال"
              onValueChange={({ value }) => {
                setRialValue(value);
              }}
            />
          </Col>
        </Row>

        <div className="d-flex flex-wrap mt-2 row-gap-2 column-gap-4">
          <div className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id="needSMS"
              className="formCheckInputs"
              checked={details.needSMS}
              onChange={e => {
                setDetails(prevDetails => ({
                  ...prevDetails,
                  needSMS: e.target.checked,
                }));
              }}
            />
            <Form.Label
              htmlFor="needSMS"
              className="mx-1 my-0 c-pointer user-select-none"
            >
              نیاز به پیامک دارم
            </Form.Label>
          </div>

          <div className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id="needCollecting"
              checked={details.needCollecting}
              className="formCheckInputs"
              onChange={e => {
                setDetails(prevDetails => ({
                  ...prevDetails,
                  needCollecting: e.target.checked,
                }));
              }}
            />
            <Form.Label
              htmlFor="needCollecting"
              className="mx-1 my-0 c-pointer user-select-none"
            >
              نیاز به جمع آوری دارم
            </Form.Label>
          </div>

          <div className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id="needPrint"
              checked={details.needPrint}
              className="formCheckInputs"
              onChange={e => {
                setDetails(prevDetails => ({
                  ...prevDetails,
                  needPrint: e.target.checked,
                }));
              }}
            />
            <Form.Label
              htmlFor="needPrint"
              className="mx-1 my-0 c-pointer user-select-none"
            >
              نیاز به پرینت دارم
            </Form.Label>
          </div>

          <div className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id="needPackaging"
              checked={details.needPackaging}
              className="formCheckInputs"
              onChange={e => {
                setDetails(prevDetails => ({
                  ...prevDetails,
                  needPackaging: e.target.checked,
                }));
              }}
            />
            <Form.Label
              htmlFor="needPackaging"
              className="mx-1 my-0 c-pointer user-select-none"
            >
              نیاز به بسته بندی دارم
            </Form.Label>
          </div>
        </div>

        <div className="w-100 mt-3">
          {loading ? (
            <Button
              className="btn-success-style rounded-0"
              type="button"
              disabled
            >
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              در حال استعلام
            </Button>
          ) : (
            <Button
              type="button"
              className="btn-success-style rounded-0"
              style={{ marginRight: 0 }}
              onClick={() => callPriceBtn()}
            >
              استعلام قیمت
            </Button>
          )}
        </div>
      </form>

      <CallForPriceModal
        data={data}
        modal={priceModal}
        setModal={setPriceModal}
        loading={loading}
      />
    </section>
  );
};

export default QuickPriceF;
